@let vorgangState = td.vorgang$ | apiAsync;

@if (td.antragFailed()) {
  <ui-api-error
    headline="Beantragung nicht möglich"
    [message]="td.antragFailedMessage()"
    [showBack]="true"
    (back)="td.showOffer()"
  />
} @else if (td.notice(); as notice) {
  <div class="flex justify-center items-center min-h-[70vh]">
    <ui-status-notice
      [headline]="notice.headline"
      [message]="notice.message"
      [state]="notice.state"
      [showBack]="true"
      [backDisabled]="td.waitsForAnswer()"
      (back)="td.startNewJourney()"
    />
  </div>
} @else if (vorgangState.data; as vorgang) {
  @let order = td.getOrder$ | apiAsync;

  <div class="pb-8">
    <!-- Back link -->
    <div class="flex items-center justify-between mb-6">
      <button
        class="flex items-center gap-4 text-cp-primary-100 font-bold text-base"
        (click)="td.goBack()"
      >
        <mat-icon svgIcon="cp-arrow-back" class="!w-4 !h-4"></mat-icon>
        <span>Zurück zum Tarifvergleich</span>
      </button>
    </div>

    <!-- Two-column layout: main (left) + sidebar (right) on desktop, stacked on mobile -->
    <div class="flex flex-col md:flex-row gap-8">
      <!-- Main column -->
      <div class="flex-1 min-w-0">
        <!-- Tariff header card -->
        <div class="mb-6">
          <ui-tarif-header
            [bafinRegNr]="vorgang.versichererBafinRegNr"
            [versichererName]="vorgang.versichererName"
            [tarifName]="vorgang.tarifName"
            [confirmedBetrag]="order.data?.bruttoBetrag ?? null"
            [provisionalBetrag]="td.provisionalBruttoBetrag$ | async"
            [state]="order.state"
          />
        </div>

        <!-- "Über den Versicherer" — mobile only -->
        <div class="md:hidden mb-6">
          <ui-versicherer-info
            [bafinRegNr]="vorgang.versichererBafinRegNr"
            [versichererName]="vorgang.versichererName"
          />
        </div>

        <!-- "Tarifdokumente" — mobile only, before Tarifdaten per Figma -->
        <div class="md:hidden mb-6">
          <ui-tarif-dokumente [dokumente]="order.data?.dokumente ?? []" [state]="order.state" />
        </div>

        <!-- Tarifdaten groups -->
        @let groupsState = td.vergleichGroups$ | apiAsync;

        @if (groupsState.state === 'loading') {
          <div class="flex justify-center py-12">
            <mat-spinner [diameter]="40" />
          </div>
        } @else if (groupsState.state === 'error') {
          <p class="py-12 text-center text-base text-cp-primary-60">
            Die Tarifdaten konnten nicht geladen werden. Bitte lade die Seite neu.
          </p>
        } @else {
          @for (group of groupsState.data; track group.name) {
            <div class="py-4 bg-cp-primary-100 rounded-lg mb-6 text-white text-center">
              <span class="font-grotesk-h6">{{ group.name }}</span>
            </div>

            <!-- Attribute rows -->
            <div class="flex flex-col mb-6">
              @for (attr of group.attribute; track attr.name) {
                <!-- Desktop: horizontal row (label left, value right) -->
                <div class="hidden md:grid md:grid-cols-[1fr_1fr] md:gap-6 md:items-center md:py-4">
                  <div class="flex items-center justify-between gap-2">
                    <span class="text-base text-cp-primary-100">{{ attr.name }}</span>
                    @if (attr.tooltip) {
                      <mat-icon
                        svgIcon="cp-info"
                        class="!w-4 !h-4 flex-shrink-0 cursor-help"
                        [matTooltip]="attr.tooltip"
                      ></mat-icon>
                    }
                  </div>
                  <ui-vergleich-box
                    [item]="attr"
                    [showBedingungstexte]="attr.bedingungstexte.length > 0"
                    class="block"
                  />
                </div>

                <!-- Mobile: stacked (label top, value bottom) -->
                <div class="md:hidden mb-4">
                  <div class="flex items-center justify-between gap-2 mb-4">
                    <span class="text-base text-cp-primary-100">{{ attr.name }}</span>
                    @if (attr.tooltip) {
                      <mat-icon
                        svgIcon="cp-info"
                        class="!w-4 !h-4 flex-shrink-0 cursor-help"
                        [matTooltip]="attr.tooltip"
                      ></mat-icon>
                    }
                  </div>
                  <ui-vergleich-box
                    [item]="attr"
                    [showBedingungstexte]="attr.bedingungstexte.length > 0"
                    class="block"
                  />
                </div>
              }
            </div>
          }
        }

        <!-- CTA — mobile only, below attribute rows -->
        <div class="md:hidden mt-6">
          <ui-tarifdetails-cta [state]="order.state" (antrag)="td.openAntrag(vorgang)" />
        </div>
      </div>

      <!-- Sidebar (desktop only) -->
      <div class="hidden md:flex md:flex-col md:w-[312px] md:flex-shrink-0">
        <div class="sticky top-4">
          <ui-versicherer-info
            [bafinRegNr]="vorgang.versichererBafinRegNr"
            [versichererName]="vorgang.versichererName"
          />
        </div>
        <div class="sticky bottom-4 mt-auto flex flex-col gap-8">
          <ui-tarif-dokumente [dokumente]="order.data?.dokumente ?? []" [state]="order.state" />
          <ui-tarifdetails-cta [state]="order.state" (antrag)="td.openAntrag(vorgang)" />
        </div>
      </div>
    </div>
  </div>
} @else if (vorgangState.error) {
  <ui-api-error [message]="vorgangState.error" [showBack]="true" (back)="td.goBack()" />
} @else {
  <div class="flex justify-center items-center min-h-[50vh]">
    <mat-spinner [diameter]="56" />
  </div>
}
